import { Component, OnInit } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';
import { ValidatorService } from 'src/app/services/validator.service';

@Component({
  selector: 'contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit{

  public dataItem:any = null;
  public loader:any   = false;

  constructor(
    public api: ApiService,
    public app: AppService,
    public validator: ValidatorService,
    private recaptchaV3Service: ReCaptchaV3Service
  ){}

  /**
   * 
   * Store
   * 
   */
  store(){

    try{  

      this.validator.clear();
      this.validator.isEmpty(this.dataItem.nome,"nome","- Informe o seu Nome.");
      this.validator.isEmpty(this.dataItem.email,"email","- Informe o seu E-mail.");
      this.validator.isEmail(this.dataItem.email,"email","- O e-mail informado é inválido.");
      this.validator.isEmpty(this.dataItem.mensagem,"mensagem","- Escreva uma mensagem.");

      if(!this.validator.passes()){

        let error = this.validator.getMessagesHtml();
        this.app.info(error);
        return false;

      }

      this.loader = true;

      this.recaptchaV3Service.execute('importantAction')
        .subscribe((token) => {

          this.dataItem.token = token;

          this.api.contato().send(this.dataItem).subscribe((response:any) => {

            this.loader  = false;

            if(response.status == 1){

              this.initDataItem();
              this.app.info("Recebemos a sua mensagem.");

            }else{

              this.app.info(response.data);

            }

          },(response:any) => {

            this.loader = false;
            let error   = this.api.formatError(response);

            this.app.info(error.message);

          });

      },(response) => { 

        this.loader   = false;
        this.app.info("Token de validação inválido. Recarregue a página para continuar.");
  
      });

    }catch(e){

      this.loader = false;

    }

  }
  /**
   * 
   * Init Data Item
   * 
   */
  initDataItem(){

    this.dataItem = {
      nome: "",
      email: "",
      mensagem: "",
      tipo: 2, 
      tipo_assunto: 2, 
      apelido: "contato-footer"
    }

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit(): void {
    this.initDataItem();
  }

}
